export default function Title({ title, subtitle }) {
  return (
    <div>
      <div className="text-3xl">
        <span className="text-3xl font-semibold">{title}</span> - {subtitle}
      </div>
    </div>
  );
}
